export default __webpack_public_path__ + "static/residence-hero-m-8dd3e55dcd77750078b8bfea6058709b.jpg";